import moment from 'moment';

const initialYear = moment([2020]);
const today = moment();
const length = today.diff(initialYear, "years") + 2;
const options = Array(length)
  .fill(0)
  .map((_, index) => {
    const date = moment(initialYear).add(index, "years");
    return {
      text: date.format("YYYY"),
      value: date.get('year'),
    };
  })
  .reverse();

export default options;

export const projectsOptions = Array(5)
  .fill(0)
  .map((_, index) => {
    const date = moment().add(index - 2, "years");
    return {
      text: date.format("YYYY"),
      value: date.get('year'),
    };
  })
  .reverse();
